import React from "react";

function Notice() {
  return (
    <div
      className="badge bg-primary rounded-0 text-center"
      style={{
        position: "relative",
        left: "50%",
        right: "50%",
        marginLeft: "-50vw",
        marginRight: "-50vw",
        width: "100vw",
      }}
    >
      TESTING
    </div>
  );
}

export default Notice;
